import './css/index.css';
import 'components/download-button/css/defaults.css';
import 'components/footer';
import 'components/breadcrumbs';
import 'components/contact-info';
import 'components/notification';
import 'components/local-navigation';
import 'components/release-calendar';
import 'components/resources-tileset';
import 'components/email-notification';
import 'components/data-download-table';
import 'components/text-block-full-width';
import 'components/cta-share-page-release';
import 'components/cta-tables-charts-data';
import 'components/link-grid-with-filters';
import 'components/link-grid-promos';
import 'components/related-charts-and-data';
import 'components/related-content-tileset';
import 'components/recent-releases-carousel';
import 'components/text-with-background-image';
import 'components/text-block-full-width-terms';
import 'components/release-calendar-with-contact';
import 'components/text-block-full-width-accordion';
import 'components/related-content-tileset-with-resources';
import 'components/text-with-background-image-with-contact';
import 'components/group-cards-data';
import 'components/card-content-image';
import 'components/card-promo-boxes';
import 'components/custom-select';
import 'components/info-overlay';
import 'components/suggested-citation';
import 'components/base-side-by-side';
import 'components/data-explorer';
import 'components/data-viz-hero';

// import last
import 'components/snippets/callouts';
import 'components/snippets/images';
import 'components/snippets/footnotes';

import DataPeriodicReleaseArchiveFilter from 'components/data-periodic-release-archive-filter';
import Mediator from 'js/mediator';
import Navigation from 'components/navigation';

Mediator.create( {

    componentClasses: [
        Navigation,
        DataPeriodicReleaseArchiveFilter,
        {
            name: 'info-overlay',
            module: () => import(
                'components/info-overlay',
            ),
        },
        {
            name: 'chart-universal',
            module: () => import(
                'components/chart-universal',
            ),
        },
    ],

    init() {

        console.info( 'The Release - Historical Release Page has initiated.' );

    },

    ready() {

        console.info( 'The Release - Historical Release Page is ready.' );

        console.info( 'Components:', this.components );

    },

} );
